import { Button, Col, Form, Row } from "react-bootstrap";

export function DynamicPRSection({ label, data, setData, keyName }) {
  const handleSectionChange = (sectionKey, field, value) => {
    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [sectionKey]: { ...prev[keyName][sectionKey], [field]: value },
      },
    }));
  };

  const handleValueChange = (sectionKey, valIndex, value) => {
    const section = data[sectionKey];
    const newValues = [...section.values];
    newValues[valIndex] = value;

    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [sectionKey]: { ...section, values: newValues },
      },
    }));
  };

  const addValue = (sectionKey) => {
    const section = data[sectionKey];
    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [sectionKey]: {
          ...section,
          values: [...section.values, ""],
        },
      },
    }));
  };

  const addSection = () => {
    const keys = Object.keys(data);
    const nextKey = String(keys.length + 1);
    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [nextKey]: {
          description: "",
          heading: "",
          subDescription: "",
          values: [""],
        },
      },
    }));
  };

  const deleteValue = (sectionKey, valIndex) => {
    const section = data[sectionKey];
    const newValues = section.values.filter((_, idx) => idx !== valIndex);

    setData((prev) => ({
      ...prev,
      [keyName]: {
        ...prev[keyName],
        [sectionKey]: { ...section, values: newValues },
      },
    }));
  };

  const deleteSection = (sectionKey) => {
    setData((prev) => {
      const newData = { ...prev[keyName] };
      delete newData[sectionKey];
      return {
        ...prev,
        [keyName]: newData,
      };
    });
  };

  return (
    <div className="mb-4 border rounded p-3">
      <label className="fs-5 text-light-gray mb-2">{label}</label>

      {Object.entries(data).map(([sectionKey, section]) => {
        const isFirstEntry = sectionKey === "1";

        return (
          <div
            key={sectionKey}
            className="p-3 border border-primary rounded mb-3"
          >
            <Row className="mb-2">
              <Col xs={10}>
                <Form.Control
                  type="text"
                  placeholder="Heading"
                  value={section.heading}
                  onChange={(e) =>
                    handleSectionChange(sectionKey, "heading", e.target.value)
                  }
                  style={{
                    fontSize: "14px",
                    marginBottom: "10px",
                  }}
                />
              </Col>
              {!isFirstEntry && (
                <Col xs={2}>
                  <Button
                    variant="outline-danger"
                    size="sm"
                    onClick={() => deleteSection(sectionKey)}
                    style={{
                      fontSize: "12px",
                      marginBottom: "10px",
                    }}
                  >
                    Delete Section
                  </Button>
                </Col>
              )}
            </Row>

            <Form.Control
              as="textarea"
              placeholder="Description"
              value={section.description}
              onChange={(e) =>
                handleSectionChange(sectionKey, "description", e.target.value)
              }
              className="mb-2 fs-5"
            />

            {/* Only show conclusion and values for entries other than key "1" */}
            {!isFirstEntry && (
              <>
                {section.values.map((val, idx) => (
                  <Row key={idx} className="mb-2">
                    <Col xs={10}>
                      <Form.Control
                        type="text"
                        placeholder="Step / Value"
                        value={val}
                        onChange={(e) =>
                          handleValueChange(sectionKey, idx, e.target.value)
                        }
                        style={{
                          fontSize: "12px",
                          marginBottom: "10px",
                        }}
                      />
                    </Col>
                    <Col xs={2}>
                      <Button
                        variant="outline-danger"
                        size="sm"
                        onClick={() => deleteValue(sectionKey, idx)}
                        style={{
                          fontSize: "12px",
                          marginBottom: "10px",
                        }}
                      >
                        Delete Value
                      </Button>
                    </Col>
                  </Row>
                ))}
                <Button
                  variant="outline-primary"
                  size="sm"
                  className="mb-2 fs-5"
                  onClick={() => addValue(sectionKey)}
                >
                  + Add Value
                </Button>

                <Form.Control
                  as="textarea"
                  placeholder="Conclusion"
                  value={section.subDescription}
                  onChange={(e) =>
                    handleSectionChange(
                      sectionKey,
                      "subDescription",
                      e.target.value
                    )
                  }
                  className="mb-2 fs-5"
                />
              </>
            )}
          </div>
        );
      })}

      <Button
        variant="outline-success"
        size="sm"
        className="fs-5"
        onClick={addSection}
      >
        + Add PR Pathway
      </Button>
    </div>
  );
}
